if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.nextAvailableDateSpan = this.querySelector('.js-inventory-next-available-date');
      this.leadTimeSpan = this.querySelector('.js-inventory-lead-time');
      this.leadTimeSpanSeperator = this.querySelector('.js-inventory-lead-time-seperator');
      this.variantInventory = this.getVariantInventory();

      // Bind to on:variant:change event for this product
      const variantPicker = this.closest('.product-info').querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      // Init
      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true'
      );
      
      // Filter the variant data based on the currentVariantId
      const currentVariantId = this.variantInventory[0].currentVariantId;
      const currentVariant = this.variantInventory.find(variant => variant.id === currentVariantId);
      //console.log("current variant=",currentVariant);
      
      // On page load call showDateTime to display the nextAvailableDate/Leadtime for the selected variant
      this.showDateTime(
        currentVariant.inventory_quantity,
        currentVariant.leadTime,
        currentVariant.nextAvailableDate,
        currentVariant.todayDate
      );

      //On page load if selected product/variant quantity <=0 then display "Backorder" on "Add to Cart" button
      if(parseInt(this.dataset.inventoryQuantity, 10) <=0) {
        var parentDivAddtoCartBtn = document.querySelector('.product-info__add-button');
        var AddtoCartBtn = parentDivAddtoCartBtn.querySelector('button');
        if(updatedVariantInventoryQuantity <=0) {
          AddtoCartBtn.textContent = "Backorder";
        }
      }
  }
    /**
     * Gets the inventory data for all product variants
     * @returns {?object}
     */
    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.variantInventory.filter(
          (variant) => variant.id === evt.detail.variant.id
        )[0];
        this.updateInventory(inventory.inventory_quantity, inventory.available);
        this.showDateTime(inventory.inventory_quantity, inventory.leadTime, inventory.nextAvailableDate, inventory.todayDate);
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
      var parentDivAddToCartBtn = document.querySelector('.product-info__add-button');
      var addToCartBtn = parentDivAddToCartBtn.querySelector('button');
      addToCartBtn.removeAttribute("disabled");
    }
    
    // Show either nextAvailableDate or leadTime based on conditions
    showDateTime(count, leadTime, nextAvailableDate, todayDate ) {
      //initially the span does not contain any text
      this.leadTimeSpan.textContent = "";
      this.nextAvailableDateSpan.textContent = "";
      this.leadTimeSpanSeperator.style.display = "none";
      
      if(count <=0) {
        if (nextAvailableDate != 'N/A') {

          //converting the string to proper date format
          const date = new Date(nextAvailableDate);
          const mm = String(date.getMonth() + 1).padStart(2, '0');
          const dd = String(date.getDate()).padStart(2, '0');
          const yyyy = date.getFullYear();
          nextAvailableDate = `${dd}/${mm}/${yyyy}`;
          todayDate = new Date(todayDate);

          //check if the nextAvailableDate is greater than today's date
          if (date >= todayDate) {
            this.nextAvailableDateSpan.textContent = ` | Next shipment: ${nextAvailableDate}`;
          } else if (leadTime != "N/A") {
            this.leadTimeSpanSeperator.style.display = "inline";
            this.leadTimeSpan.textContent = `Non-stock, standard lead time ${leadTime}`;
          }      
        } else if (leadTime != 'N/A'){
          this.leadTimeSpanSeperator.style.display = "inline";
          this.leadTimeSpan.textContent = `Non-stock, standard lead time ${leadTime}`;
        }
      }
    }

    /**
     *
     * Updates the inventory notice
     * @param {number} count - the inventory quantity available
     * @param {boolean} available - whether current variant is available
     */
    updateInventory(count, available) {
      let inventoryLevel;
      if (count <= 0) {
        if (available) {
          // inventoryLevel = 'in_stock';
        // } else {
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      if (this.dataset.showNotice === 'always'
        || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low'))) {
        this.hidden = false;

        // Set the inventory level data attribute
        this.setAttribute('data-inventory-level', inventoryLevel);
        
        //Set the inventory quantity data attribute
        this.setAttribute('data-inventory-quantity', count);

        // Determine whether to show the count or not
        if (inventoryLevel === 'none') {
          this.inventoryNotice.innerText = "On Backorder";
        } else if (inventoryLevel !== 'in_stock' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
          this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
        } else if (inventoryLevel.includes('low')) {
          this.inventoryNotice.innerText = theme.strings.lowStock;
        } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
          this.inventoryNotice.innerText = theme.strings.inStock;
        }

        // Update urgency message if needed
        if (this.urgencyMessage) {
          if (inventoryLevel === 'very_low') {
            this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
          } else if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML = this.dataset.textLow;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.urgencyMessage.innerHTML = this.dataset.textNormal;
          } else if (inventoryLevel === 'none') {
            this.urgencyMessage.innerHTML = ""; //this.dataset.textNoStock;
          }
        }

        // Update the bar indicator
        if (this.indicatorBar) {
          this.indicatorBar.hidden = false;

          let newWidth;
          if (count >= this.dataset.scale || inventoryLevel === 'in_stock') {
            newWidth = 100;
          } else {
            newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
          }
          this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
        }
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
